import * as React from "react"

/**
 * THIS IS A GENERATED FILE, DO NOT MODIFY MANUALLY.
 * Modify .svg in src/assets/icons/ and generate code again with 'yarn generate-icons'.
 */
export const MentalHealthIcon: React.FC<React.SVGProps<
  SVGSVGElement
>> = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 48 48"
      {...props}
    >
      <defs>
        <clipPath id="prefix__a">
          <path d="M0 0h48v48H0z" />
        </clipPath>
      </defs>
      <g clipPath="url(#prefix__a)">
        <path d="M24 11.526v29c9.062-6.214 14.084-11.924 16.5-16.689 2.507-4.951 2.2-8.826.824-11.511C38.4 6.612 30.3 5.047 25.883 9.588zm0 32.162c-40.25-26.597-12.393-47.356-.462-36.376.158.144.312.294.462.449q.222-.232.462-.446C36.391-3.673 64.251 17.088 24 43.688z" />
      </g>
    </svg>
  )
}
